export const FETCHING_DISPATCH_ORDERS_LIST = '@@toyota/FETCHING_DISPATCH_ORDERS_LIST';
export const FETCHED_DISPATCH_ORDERS_LIST = '@@toyota/FETCHED_DISPATCH_ORDERS_LIST';
export const FETCHED_DISPATCH_ORDERS_LIST_FAILED = '@@toyota/FETCHED_DISPATCH_ORDERS_LIST_FAILED';

export const FETCHING_DISPATCH_ORDER = '@@toyota/FETCHING_DISPATCH_ORDER';
export const FETCHED_DISPATCH_ORDER = '@@toyota/FETCHED_DISPATCH_ORDER';
export const FETCHED_DISPATCH_ORDER_FAILED = '@@toyota/FETCHED_DISPATCH_ORDER_FAILED';
export const CLEAR_DISPATCH_ORDER = '@@toyota/CLEAR_DISPATCH_ORDER';

export const FETCHING_VEHICLES_TYPES_LIST = '@@toyota/FETCHING_VEHICLES_TYPES_LIST';
export const FETCHED_VEHICLES_TYPES_LIST = '@@toyota/FETCHED_VEHICLES_TYPES_LIST';
export const FETCHED_VEHICLES_TYPES_LIST_FAILED = '@@toyota/FETCHED_VEHICLES_TYPES_LIST_FAILED';

export const FETCHING_CANDIDATES_VEHICLES = '@@toyota/FETCHING_CANDIDATES_VEHICLES';
export const FETCHED_CANDIDATES_VEHICLES = '@@toyota/FETCHED_CANDIDATES_VEHICLES';
export const FETCHED_CANDIDATES_VEHICLES_FAILED = '@@toyota/FETCHED_CANDIDATES_VEHICLES_FAILED';
export const CLEAR_CANDIDATES_VEHICLES = '@@toyota/CLEAR_CANDIDATES_VEHICLES';

export const SAVING_DISPATCH_ORDER = '@@toyota/SAVING_DISPATCH_ORDER';
export const SAVED_DISPATCH_ORDER = '@@toyota/SAVED_DISPATCH_ORDER';
export const SAVED_DISPATCH_ORDER_FAILED = '@@toyota/SAVED_DISPATCH_ORDER_FAILED';

export const ADDING_DISPATCH_ORDER = '@@toyota/ADDING_DISPATCH_ORDER';
export const ADDED_DISPATCH_ORDER = '@@toyota/ADDED_DISPATCH_ORDER';
export const ADDED_DISPATCH_ORDER_FAILED = '@@toyota/ADDED_DISPATCH_ORDER_FAILED';

export const APPROVING_DISPATCH_ORDER = '@@toyota/APPROVING_DISPATCH_ORDER';
export const APPROVED_DISPATCH_ORDER = '@@toyota/APPROVED_DISPATCH_ORDER';
export const APPROVED_DISPATCH_ORDER_FAILED = '@@toyota/APPROVED_DISPATCH_ORDER_FAILED';

export const CANCELLING_DISPATCH_ORDER = '@@toyota/CANCELLING_DISPATCH_ORDER';
export const CANCELLED_DISPATCH_ORDER = '@@toyota/CANCELLED_DISPATCH_ORDER';
export const CANCELLED_DISPATCH_ORDER_FAILED = '@@toyota/CANCELLED_DISPATCH_ORDER_FAILED';

